import React, { useContext, useMemo } from 'react';
import operActionPlanService from '../../../../../services/operActionPlanService';
import useServiceReducer from '../../../../../shared/hooks/useServiceReducer';
import { IdRoute } from '../../../../../types';
import Context from './ActionPlanItemContext';
import actionPlanItemReducer from './ActionPlanItemReducer';
import MainContext from '../../../../App/MainProvider/context';

const ActionPlanProvider: React.FC<IdRoute> = ({ id: operationActionPlanId, children }) => {
  const { inSuperUserMode, inGuidanceServiceMode } = useContext(MainContext);
  const [context, loading, , , , reload] = useServiceReducer(
    operActionPlanService.getActionPlanItemContext,
    actionPlanItemReducer,
    operationActionPlanId,
    [inSuperUserMode(), inGuidanceServiceMode()]
  );
  const value = useMemo(
    () =>
      context && {
        operationActionPlan: context.operationActionPlan,
        operationActionPlanItems: context.operationActionPlanItems,
        operationActionPlanDocuments: context.operationActionPlanDocuments,
        operationActionPlanExternalLinks: context.operationActionPlanExternalLinks,
        reload,
        loading,
      },
    [context, reload, loading]
  );

  if (!value) {
    return null;
  }

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default ActionPlanProvider;
